import { IOverlayProps } from '@blueprintjs/core';
import React from 'react';
import ContentOverlay from '../../../components/ContentOverlay';
import ErrorCard from '../../../components/ErrorCard';
import LoadingCard from '../../../components/LoadingCard';
import { useDonorEditLazyQuery } from '../../../generated/graphql';
import DonorForm from './DonorForm';

interface IDonorEditOverlayProps extends IOverlayProps {
  id: string;
  onClose: () => void;
}

const DonorEditOverlay = ({ id, ...overlayProps }: IDonorEditOverlayProps) => {
  const [loadDonor, { data, called, loading, error }] = useDonorEditLazyQuery({
    variables: {
      id,
    },
  });

  if (overlayProps.isOpen && !loading && !called) {
    loadDonor();
  }

  const renderContent = () => {
    if (loading) return <LoadingCard />;
    if (error || !data || !data.donor) return <ErrorCard />;
    return (
      <DonorForm
        onCancel={() => overlayProps.onClose?.()}
        onUpdated={() => {
          loadDonor();
          overlayProps.onClose?.();
        }}
        initialValues={data.donor}
      />
    );
  };

  return <ContentOverlay {...overlayProps}>{renderContent()}</ContentOverlay>;
};

export default DonorEditOverlay;
